module.exports = __webpack_public_path__ + "d6413ba1/img/print-icon.d8dbbca5.svg";